import { render, staticRenderFns } from "./Quotation-Table.vue?vue&type=template&id=9d9f18a6&scoped=true"
import script from "./Quotation-Table.vue?vue&type=script&lang=js"
export * from "./Quotation-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f18a6",
  null
  
)

export default component.exports